React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'DeleteOrgButtonComponent'

  render: t.renderable ->
    { onClick } = @props

    t.div '.window-module.u-gutter', ->
      t.b onClick, '.quiet-button', style: { padding: '6px 11px', marginTop: '32px' }, ->
        t.format 'delete-this-organization'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/delete-org-button-component.coffee